import { styled as e, modifier as r, css as i } from "@lokalise/styled";
import { value as o, spacing as l } from "../../utils/theme/index.js";
const s = e.label`
	all: initial;
	cursor: pointer;
	font-family: ${o("font.family.default")};
	display: inline-grid;
	grid-template-columns: 1fr 1fr;
	border-radius: ${o("radius.m")};
	border: 1px solid ${o("color.border.default")};
	position: relative;
	user-select: none;
	overflow: hidden;
	font-size: 10px;
	line-height: 14px;
	text-transform: uppercase;
	min-width: max-content;

	${r(
  "$checked",
  i`
			border-color: ${o("color.border.active")};
		`
)}
`, t = e.input`
	// To fight specificity issues, we wrap this class with input.class-name selector
	// which makes it more specific than global bootstrap styles.
	input& {
		// Overrides for global css
		all: initial;
		position: absolute !important;
		line-height: initial;

		border: none;
		clip: rect(0px, 0px, 0px, 0px);
		height: 1px;
		width: 1px;
		margin: -1px;
		padding: 0;
		overflow: hidden;
		white-space: nowrap;
	}
`, c = e.span`
	padding: ${l(1)};
	text-align: center;
	color: ${o("color.text.default")};
	background-color: ${o("color.border.default")};

	${r(
  "$highlighted",
  i`
			color: ${o("color.text.inverse")};
			background-color: ${o("color.border.active")};
		`
)}
	${t}[disabled] ~ & {
		cursor: not-allowed;
	}
`, d = e.span`
	width: 50%;
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	background-color: ${o("color.background.input.default")};
	transition: transform 0.05s ease-in;

	${t}[aria-checked="true"] ~ & {
		transform: translateX(100%);
	}
	${t}[disabled] ~ & {
		cursor: not-allowed;
	}
`;
export {
  c as ToggleHandle,
  t as ToggleInput,
  s as ToggleLabel,
  d as ToggleMask
};
//# sourceMappingURL=styles.js.map
